import React from 'react';
import styled from 'styled-components';

const CustomRow = styled.div`
  border-bottom: 1px #4E1B75 solid;
  width: 100%;
  margin-bottom: 16px;
  padding-bottom: 4px;
`;

const CustomText = styled.span`
  color: #4E1B75;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

type Props = {
  children: React.ReactNode
}

const RowSection: React.FC<Props> = ({ children }) => {
  return (<CustomRow>
    <CustomText>{children}</CustomText>
  </CustomRow>);
};

export default RowSection;